<template>
    <el-row>
        <el-upload class="upload-demo" ref="uploadFile" action="" :http-request="httpRequest" :file-list="fileList1"
            :on-remove="handleRemove" show-file-list :before-upload="beforeAvatarUpload" :on-preview="handleOnPreview" :on-exceed="onExceed"
            :limit="limit">
            <div>
                <el-button class="searchBtn" style="width: 1.6rem"><i class="el-icon-upload2"></i>上传附件</el-button>
                <span class="customText">
                    {{customText}}
                </span>
            </div>
            <div slot="tip" class="el-upload__tip" v-if="isMessage">{{isFileType.length == 1 ? '限文件' : '限文件，图片'}}
                {{isFileType.length == 1 ? 'doc,docx,pdf' : 'doc,docx,pdf,jpg,jpeg,png,bmp,gif'}}</div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </el-row>
</template>
<script>
import { uploadFile, fileDownload } from '@/api/user'
export default {
    props: {
        attachmentUrlList: {
            default: '',
            type: String
        },
        limit: {
            default: 5,
            type: Number
        },
        isMessage: {
            default: true,
            type: Boolean
        },
        // ['file'] 仅文件 ['file', 'img']  图片 文件
        isFileType: {
            default: () => ['file'],
            type: Array
        },
        customText: {
            default: '',
            type: String
        }
    },
    data() {
        return {
            dialogImageUrl: '',
            fileList: [],
            fileList1: [],
            dialogVisible: false,
            imgType: ["jpg", "JPG", "png", "PNG", "jpeg", "JPEG", 'gif', "bmp"],
            fileType: ["docx", "doc", 'pdf', 'PDF'],
        };
    },
    watch: {
        attachmentUrlList: {
            handler: function (val) {
                if (val) {
                    let newArrFile = val.split(',')
                    newArrFile = newArrFile.filter(v => v !== '')
                    this.fileList = (newArrFile.length > 0 ? newArrFile : []).map(url => {
                    let newArr = url.split('/').slice();
                        return {
                            url: process.env.VUE_APP_BASE_API + '/minio/getImage?fileName=' + url,
                            name: newArr[2],
                            code: url,
                        }
                    })
                    this.fileList1 = JSON.parse(JSON.stringify(this.fileList));
                } else {
                    this.fileList = []
                    this.fileList1 = []
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        handleRemove(file, fileList) {
            this.fileList = fileList
            this.$emit('handleFile', this.fileList)
        },
        async handleOnPreview(file) {
            let res = await fileDownload(file.url.split('=')[1])
            let blob = new Blob([res.data], { type: res.data.type })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = `${file.name}.${file.name.split('.')[1]}`
            link.click()
        },
        async httpRequest(param) {
            let file = param.file
            let fd = new FormData()
            fd.append('file', file)
            let res = await uploadFile(fd)
            let newRes = { ...res };
            let newArr = newRes.result.split('/').slice();
            if (res.code === 0) {
                this.fileList.push({
                    url: process.env.VUE_APP_BASE_API + '/minio/getImage?fileName=' + res.result,
                    code: res.result,
                    name: newArr[2]
                })
                this.fileList1 = JSON.parse(JSON.stringify(this.fileList));
                this.$emit('handleFile', this.fileList1)
            } else {
                this.$message.error(res.message)
            }
        },
        onExceed(files, fileList) {
            this.$message.warning('最多支持上传5个文件!')
        },
        beforeAvatarUpload(file) {
            // 格式过滤
            if (this.isFileType.length === 1) { // file
                let FileExt = file.name.substring(file.name.lastIndexOf('.') + 1)
                const extension = this.fileType.includes(FileExt)
                if (!extension) {
                    this.$message.error('上传文件格式不正确')
                }
                return extension
            } else { // file || img
                let FileExt = file.name.substring(file.name.lastIndexOf('.') + 1)
                const extension = this.fileType.includes(FileExt)
                const extension1 = this.imgType.includes(FileExt)
                if (!(extension || extension1)) {
                    this.$message.error('上传文件格式不正确')
                }
                return extension || extension1
            }
        },
    }
}
</script>
<style>
.customText{
    color: red;
    font-size: 12px;
}
</style>